<script lang="ts" setup>
  import { toRefs, useSlots, type VNode } from 'vue'
  import ListDescriptionItem from './ListDescriptionItem.vue'
  import type { ListDescriptionItemType } from '@/elements/ListDescriptionItem.vue'

  interface Props {
    items?: (ListDescriptionItemType | undefined)[]
    small?: boolean
    header?: string
    defaultColsNumber?: number
  }

  const props = withDefaults(defineProps<Props>(), { defaultColsNumber: 1, items: undefined, small: undefined, header: undefined })

  const { items, small, header, defaultColsNumber } = toRefs(props)

  const slotUse = useSlots()
  const slots: VNode[] | undefined = slotUse.default ? slotUse.default() : undefined
  const slotsCount = slots?.length ?? 0

  const getItemClassByIndex = (index: number, isSlot: boolean) => {
    const classes: string[] = []
    if (!isSlot) {
      if (slotsCount == 0 && index + 1 != items.value?.length) classes.push('border-b')
      // if (index == 0) classes.push('rounded-l-md rounded-r-none')
    } else {
      if (items.value?.length == 0 && index == 0) classes.push('rounded-l-md rounded-r-none')
      if (index + 1 == slotsCount) classes.push('rounded-r-md rounded-l-none')
      classes.push('rounded-none')
    }
    return classes.join(' ')
  }

  function getLineClass(item: ListDescriptionItemType) {
    if (typeof item === 'object' && Object.keys(item).includes('lineClass')) return item.lineClass
    return []
  }
</script>
<template>
  <ul>
    <li
      v-if="header"
      :class="[{ 'p-1': small }, { 'p-4': !small }]"
      class="text-sm font-semibold underline">
      {{ header }}
    </li>
    <template v-if="items">
      <li
        v-for="(item, index) in <ListDescriptionItemType[]>items.filter((itm) => !!itm)"
        :key="item.title"
        :class="[getItemClassByIndex(index, false), `grid gap-2 grid-cols-${defaultColsNumber} md:gap-4 md:grid-cols-2 hover:bg-gray-50 dark:hover:bg-gray-950`, { 'p-1': small }, { 'p-4': !small }, getLineClass(item)]">
        <ListDescriptionItem
          :both-class="item.bothClass"
          :description="item.description"
          :description-class="item.descriptionClass"
          :effort-id="item.effortId"
          :effort-link-class="item.effortLinkClass"
          :html="item.html"
          :title="item.title"
          :title-class="item.titleClass"
          :tooltip="item.tooltip" />
      </li>
    </template>
    <template v-if="slots">
      <li
        v-for="(item, index) in slots"
        :key="`slot-${index}`"
        :class="[getItemClassByIndex(index, true)]"
        class="grid gap-2 grid-cols-1 md:gap-4 md:grid-cols-2 hover:bg-gray-50 px-1 py-1">
        <component :is="item" />
      </li>
    </template>
    <template v-if="!items && !slots">
      <span class="ml-5">keine Daten gefunden</span>
    </template>
    <li
      v-if="$slots.footer"
      class="text-sm font-medium leading-6 p-1">
      <slot name="footer"></slot>
    </li>
  </ul>
</template>
